import React, { useEffect } from 'react';
import PageTitle from 'ui/views/layouts/BaseLayout/PageTitle';
import MaxWidth, { maxWidths } from 'ui/views/containers/MaxWidth';
import styled from '@emotion/styled';
import { bluePlanetTheme } from 'ui/theme';
import { contentSpacing, halfSpacing, sectionSpacing } from 'ui/theme/themeConstants';
import { css } from '@emotion/react';
import { useMobileHeader } from 'domain/shared/Navigation';
import ScrollableBody from '../BaseLayout/ScrollableBody';
import { scrollToTop } from 'util/scroll';
import { CommunityConfiguration, TinyCommunity } from 'types/company/community';
import CommunityHeader from './CommunityHeader';

export const communityBleedAmounts = {
  xs: halfSpacing, // Same as <MobileMargin>
  sm: contentSpacing,
  md: sectionSpacing,
  lg: sectionSpacing,
};

const horizontalSpacing = css`
  margin: 0 auto;
  max-width: ${maxWidths.xl};
  width: 100%;
  padding-left: 0;
  padding-right: 0;
  ${bluePlanetTheme.breakpoints.up('sm')} {
    padding-left: ${contentSpacing};
    padding-right: ${contentSpacing};
  }
  ${bluePlanetTheme.breakpoints.up('md')} {
    padding-left: ${sectionSpacing};
    padding-right: ${sectionSpacing};
  }
`;

export const HorizontalSpacing = styled.div`
  ${horizontalSpacing}
`;

export const Main = styled.main`
  ${horizontalSpacing}
  padding-top: ${contentSpacing};
  padding-bottom: ${contentSpacing};
`;

export default function CommunityPage({
  title,
  backHref,
  subheading,
  community,
  configuration,
  children,
  mobileHeaderTitle,
  disableSearch,
  imageURL,
}: {
  community: TinyCommunity;
  configuration: CommunityConfiguration;
  title: string;
  mobileHeaderTitle?: string;
  subheading?: React.ReactNode;
  children?: React.ReactNode;
  backHref?: string;
  disableSearch?: boolean;
  imageURL?: string;
}) {
  useEffect(() => {
    scrollToTop();
  }, []);

  useMobileHeader(mobileHeaderTitle ?? title);
  return (
    <>
      <PageTitle title={title} />
      <ScrollableBody accountForMobileHeader>
        <div className="u-flex-center" style={{ backgroundColor: bluePlanetTheme.bluePlanetPalette.white }}>
          <MaxWidth width="xl">
            <CommunityHeader
              backHref={backHref}
              subheading={subheading}
              community={community}
              configuration={configuration}
              disableSearch={disableSearch}
              imageURL={imageURL}
            />
          </MaxWidth>
        </div>
        {children}
      </ScrollableBody>
    </>
  );
}
